// extracted by mini-css-extract-plugin
export default {"button":"PlayButton_button__fN5tv","ring":"PlayButton_ring__6QyFA","play":"PlayButton_play__P67Yb"};